import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DistributionScanComponent } from './distribution-scan.component';
import { UiComponentsModule } from '../../../../components/ui/ui.module';
import { ScanControlPanelComponent } from './components/scan-control-panel/scan-control-panel.component';
import { ScanSummaryCardComponent } from './components/scan-summary-card/scan-summary-card.component';
import { ModalModule } from 'ngx-bootstrap/modal';

@NgModule({
  declarations: [DistributionScanComponent, ScanControlPanelComponent, ScanSummaryCardComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    UiComponentsModule,
    ModalModule.forRoot()
  ],
  exports: [DistributionScanComponent]
})
export class DistributionScanModule { }



// WEBPACK FOOTER //
// /app/src/app/pages/admin/qrcode/distribution-scan/distribution-scan.module.ts